import { useState, useEffect } from "react";

const LAUNCH_DATE = new Date("2026-06-04T08:00:00Z").getTime(); // 6:00 PM AEST

export default function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  function getTimeLeft() {
    const now = Date.now();
    const diff = Math.max(0, LAUNCH_DATE - now);
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  const blocks = [
    { value: timeLeft.days, label: "Days" },
    { value: timeLeft.hours, label: "Hours" },
    { value: timeLeft.minutes, label: "Minutes" },
    { value: timeLeft.seconds, label: "Seconds" },
  ];

  return (
    <div data-testid="countdown-timer" className="flex gap-3 sm:gap-4">
      {blocks.map((block) => (
        <div
          key={block.label}
          className="flex flex-col items-center border border-[rgba(212,175,55,0.3)] bg-[#0a0a0a] px-3 sm:px-5 py-3 rounded-sm min-w-[60px] sm:min-w-[76px]"
        >
          <span className="countdown-digit text-3xl sm:text-4xl text-white leading-none">
            {String(block.value).padStart(2, "0")}
          </span>
          <span className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-[#D4AF37] mt-1 font-medium">
            {block.label}
          </span>
        </div>
      ))}
    </div>
  );
}
